<nav
  class="gradient navbar w-full h-auto py-10 fixed flex justify-center items-center bg-transparent top-0 left-0 z-50 invisible show-after-delay-1-5">
  <div class="page-content-padding page-content-max-width w-full flex justify-between items-center">
    <div class="gap-6 flex max-xl:hidden text-sm items-center">
      <img
        src="/images/klubovna-logo.svg"
        (click)="navigateToHomeTop('navbar_logo_')"
        class="max-xl:hidden max-w-[150px] cursor-pointer"
        alt="(k)lubovna logo" />
      @for (menuItem of menuItemsFiltered(); track menuItem.id) {
        <p
          class="uppercase cursor-pointer hover:text-neon h-fit"
          (click)="navigateOrScroll(menuItem, 'navbar')"
          [class]="activeMenuItemId() === menuItem.id ? 'text-neon' : 'text-white'">
          {{ menuItem.key | translate }}
        </p>
      }
    </div>
    <div class="gap-6 hidden justify-center items-center max-xl:flex">
      <span
        class="material-symbols-outlined text-white"
        (click)="openMenu()">
        menu
      </span>
    </div>

    <div class="flex gap-4">
      <k-button
        [gtagLabel]="'language_navbar'"
        (click)="changeLanguage()"
        [circle]="true"
        [outlined]="true">
        {{ languageButtonLabelSig() }}
      </k-button>
      <k-button
        [gtagLabel]="'become_a_member_navbar'"
        [showIconOnMobile]="false"
        [icon]="'south_west'"
        (click)="
          navigateOrScroll({ id: 'membership_program', key: 'become_a_member', routerLink: '/membership-program' })
        ">
        {{ 'become_a_member' | translate }}
      </k-button>
    </div>
  </div>
</nav>

<div
  #overlay
  (click)="closeMenu()"
  class="fixed z-50 w-full h-[100dvh] bg-night/70 top-0 flex items-end overflow-hidden will-change-auto opacity-0 pointer-events-none"></div>

<div
  #mobileMenu
  (click)="$event.stopPropagation()"
  class="fixed bottom-0 z-[60] w-full h-[75%] bg-neon rounded-t-[16px] flex flex-col will-change-transform translate-y-full">
  <div class="w-full h-auto p-6 flex justify-between">
    <div class="gap-3 flex">
      <k-button
        [outlined]="true"
        [circle]="true"
        (click)="closeMenu(); scrollToTop()"
        [color]="buttonColors.Black">
        <span class="material-symbols-outlined text-[16px]">north</span>
      </k-button>
      <k-button
        [gtagLabel]="'language_navbar_mobile'"
        (click)="changeLanguage()"
        [color]="buttonColors.Black"
        [circle]="true"
        [outlined]="true">
        {{ languageButtonLabelSig() }}
      </k-button>
    </div>
    <k-button
      [gtagLabel]="'close_navbar_mobile'"
      [outlined]="true"
      [color]="buttonColors.Black"
      [circle]="true"
      (click)="closeMenu()">
      <span class="material-symbols-outlined text-[16px]">close</span>
    </k-button>
  </div>
  <div class="grow w-full p-8 justify-end flex-col flex">
    <div class="flex flex-col justify-center h-full">
      @for (menuItem of mobileMenuItemsFiltered(); track menuItem.id) {
        <p
          (click)="clickMenuElement(menuItem, 'navbar_mobile')"
          class="text-[24px] leading-[36px]">
          {{ menuItem.key | translate }}
        </p>
      }
    </div>
    <div class="flex justify-between flex-wrap gap-4">
      <k-button
        [color]="buttonColors.Black"
        [icon]="'north_east'"
        (click)="
          closeMenu();
          navigateOrScroll({ id: 'membership_program', key: 'become_a_member', routerLink: '/membership-program' })
        ">
        {{ 'become_a_member' | translate }}
      </k-button>
      <div class="flex gap-3">
        @for (socialItem of socialItems; track socialItem.platform) {
          <a
            [href]="socialItem.link"
            class="block hover:underline"
            target="_blank"
            rel="noopener noreferrer">
            <k-button
              [gtagLabel]="socialItem.handle + 'navbar_mobile'"
              [outlined]="true"
              [circle]="true"
              [color]="buttonColors.Black">
              <img
                class="w-5 h-5"
                [src]="socialItem.icon"
                alt="" />
            </k-button>
          </a>
        }
      </div>
    </div>
  </div>
  <div
    class="w-full h-auto"
    (click)="closeMenu(); navigateToHomeTop('navbar_mobile_logo_')">
    <img
      src="/images/klubovna-logo-night.svg"
      alt=""
      class="relative top-4 right-2" />
  </div>
</div>
